import { Outlet } from 'react-router-dom';
import ContainerMensagem from './components/container';
import { ProviderServicesMensagens } from './context/getMembros';

export default function Mensagens() {

  return (
    <>
      <ProviderServicesMensagens>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerMensagem />
          <Outlet />
        </div>
      </ProviderServicesMensagens>

    </>
  )
}

//   (<Formulario
//     tituloFiltro={false}
//     tituloFormulario='Mensagens'
//     atualizar={true}
//     urlFiltroPesquisarPrincipal={''}
//     urlFiltroPesquisarSegundario={''}
//     tituloFiltroSelecoes={'Eventos'}
//     usuario={getUsuario}
//     activeIncluirCadastro
//     cabecalhoDeRelatorios={["Ministério", "Tipo", "Frequência", "Mensagem", "Link Youtube"]}
//     conteudoRelatorios={["ministerioGrupo", "tipo", "frequencia", "mensagem", "link"]}
//     url={"https://logtech.solutions:9292/agendamento/bot"}
//     cabeca={["Ministério", "Tipo", "Frequência", "Mensagem", "Link Youtube"]}
//     conteudo={["ministerioGrupo", "tipo", "frequencia", "mensagem", "link"]}
//     urlAlteracao={`https://logtech.solutions:9292/visitante`}
//     identificador='id'
//     filtrar
//     descricaoDoFiltro='descricao'
//     tituloDetails='Tarefas de Evento'
//     tipoDeExcel={"exportarPesquisaUniversal"}
//     tipoAlteracaoCadastro='SET_USER'
//     activeAlteracaoCadastro={true}
//   />
// )

{/* <section style={{ display: 'flex', gap: '0.3em' }}>
        <Options
          value={usuario?.sede ? usuario?.nome_sede : false}
          name=''
          largura={33}
          titulo='Sede'
          lerApenas={usuario?.sede ? true : false}
          required={true}
          alterarEstado={(sede: any) => setSede(+sede.target.value)}
          nomeDescriminadorDasOpcoes='social'
          nomeDescriminador={'id'}
          possiveisSelecoes={sedes}
        />
        <Options
          value={usuario ? usuario?.ministerio : false}
          name='ministerioGrupo'
          largura={33}
          titulo='Ministério'
          lerApenas={usuario?.ministerio ? true : false}
          required={true}
          nomeDescriminadorDasOpcoes='descricao'
          nomeDescriminador={'id'}
          possiveisSelecoes={ministerioGrupos?.filter((ministerio: any, index: any) => ministerio.sede == sede)}
        />
        <Options
          value={usuario?.tipo ?? false}
          name='tipo'
          largura={33}
          titulo='Tipo'
          lerApenas={usuario?.tipo ? true : false}
          required={true}
          alterarEstado={(tarefa: any) => setDescricao(tarefa.target.value)}
          nomeDescriminadorDasOpcoes='descricao'
          nomeDescriminador={'descricao'}
          possiveisSelecoes={[{ descricao: 'Agendado' }]}
        />
        <Options
          value={usuario?.frequencia ? usuario?.frequencia : false}
          name='frequencia'
          largura={33}
          titulo='Frequência'
          lerApenas={usuario?.atividade ? true : false}
          required={true}
          alterarEstado={(tarefa: any) => setDescricao(tarefa.target.value)}
          nomeDescriminadorDasOpcoes='descricao'
          nomeDescriminador={'id'}
          possiveisSelecoes={frequencia}
        />
      </section>
      <section style={{ display: 'flex', gap: '0.3em' }}>
        <Inputs
          value={usuario?.mensagem}
          name='mensagem'
          largura={33}
          titulo='Mensagem'
          tipo={'text'}
          required={false}
          segundos={1} />
        <Inputs
          value={usuario?.link}
          name='link'
          largura={33}
          titulo='Link'
          tipo={'text'}
          required={false} />
      </section> */}
